import {
  GET_DASHBOARD_DATASET,
  requestType,
  failedType,
  succeedType,
} from "./../actions/actionTypes";

const initState = {
  result: {},
  is_fetching: false,
};

export const dashboardReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(GET_DASHBOARD_DATASET):
      return {
        ...state,
        is_fetching: true,
      };
    case failedType(GET_DASHBOARD_DATASET):
      return {
        ...state,
        is_fetching: false,
      };
    case succeedType(GET_DASHBOARD_DATASET):
      return {
        ...state,
        is_fetching: false,
        result: action.payload,
      };
    default:
      return state;
  }
};
